import React from "react"
import Consumer from "../../layouts/Context"
import { TweenMax, Power3 } from "gsap/TweenMax"
import TransitionLink from 'gatsby-plugin-transition-link'

// Components
import ArrowQA from "../ArrowBtn/images/arrow-salmon.png"
import ArrowGreen from "../ArrowBtn/images/arrow-green.png"
import ArrowBlue from "../ArrowBtn/images/arrow-blue.png"

class ArticleHeaderBtn extends React.Component {

  exitArticle = (node, e, exit, entry) => {
    this.context.set({
      homeInit: true
    })

    TweenMax.to(this.props.pageWipe, .75, {ease: Power3.easeOut, x: "0"})
  }

  render() {
    const {style} = this.props

    let icon

    switch (style) {
      case ('qa'):
        icon = ArrowQA
        break;
      case ('digital'):
        icon = ArrowGreen
        break;
      default:
        icon = ArrowBlue
    }

    return (
      <TransitionLink
        to="/"
        aria-label="Back"
        className="arrow arrow--white"
        title="Back"
        exit={{
          trigger: ({node, e, exit, entry}) => this.exitArticle(node, e, exit, entry),
          length: .75,
          zIndex: 2
        }}
        entry={{
          length: .75,
          delay: .75,
          zIndex: 1
        }}
      >
        <img src={icon} title="Back" width="165" height="105" alt="Back" />
      </TransitionLink>
    )
  }
}

ArticleHeaderBtn.contextType = Consumer

export default ArticleHeaderBtn